import React from "react";
import ReactDOM from "react-dom/client"; // ✅ Correct import
import "./index.css";
import App from "./App";
import DeviceProvider from "./context/DeviceContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <DeviceProvider>
      <App />
    </DeviceProvider>
  </React.StrictMode>
);